module.exports = __webpack_public_path__ + "img/12.12557e55.svg";